import React from 'react'
import { connect } from 'react-redux'
import { Icon } from "semantic-ui-react";
import { DropdownItem } from "semantic-ui-react";
import { DropdownMenu } from "semantic-ui-react";
import { Dropdown } from "semantic-ui-react";
 import { Menu } from 'semantic-ui-react';
import { createEntityWithDefaults } from "../../actions/entities";
import NewEntityModal from "../entities/NewEntityModal";
import InvoiceForm from "./InvoiceForm";

class ActionsMenu extends React.Component {

  render() {
    const {invoice} = this.props

    return (
      <Dropdown key={'dossier_actions_dropdown'} floating icon item
        trigger={<a> <Icon name='ellipsis horizontal' style={{margin:0}}/> </a>}>
          <DropdownMenu>
            <DropdownItem icon='download' text={'downloaden'} href={Routes.invoice_path({id: invoice.id, format: 'pdf', download: true, _options: true})}/>

            {!invoice.creditNoteReference && <NewEntityModal entityName={'invoice'} form={this.CreditNoteForm}
                                                                      header={I18n.t('api.forms.invoice.new.credit_note_header', {invoice_number: invoice.identification})}
                                                                      createEntityWithDefaults={this.props.createCreditNote}
                                                                      trigger={ this.renderCreditNoteDropDownItem }
            />}
          </DropdownMenu>
      </Dropdown>
      )
  }

  renderCreditNoteDropDownItem(props){
    return(<DropdownItem onClick={props.onClick}>
          <Icon  name='euro' color='red'  />
      {I18n.t('api.forms.invoice.new.credit_note')}
      </DropdownItem>)
  }

  CreditNoteForm = (props) => {
    return <InvoiceForm {...props} creditNote/>
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    createCreditNote: () => {
      let invoice = ownProps.invoice
      let creditNote = {...invoice}
      creditNote.creditNoteReferenceInvoiceId = invoice.id
      creditNote.paid = false
      const creditNoteId =  dispatch(createEntityWithDefaults('invoice', creditNote))
      invoice.invoiceItems.forEach((item) => {
        let creditNoteItem = {...item}
        creditNoteItem.invoiceId = creditNoteId
        dispatch(createEntityWithDefaults('invoiceItem', creditNoteItem))
      })

      return creditNoteId
    },
  }
}

export default connect(null, mapDispatchToProps)(ActionsMenu)
